module.exports = __webpack_public_path__ + "download_img-55fcb5bb.png";